import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';
import Breadcrumb from '../../../components/feature/Breadcrumb';
import FAQSchema from '../../../components/feature/FAQSchema';
import { useEffect } from 'react';

export default function KocaeliPage() {
  useEffect(() => {
    document.title = 'Kocaeli Fiber Optik ve Güvenlik Sistemleri | Fiber Ek Hizmeti';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Kocaeli fiber kablo tamiri, fiber ek hizmeti, fusion splicing, OTDR test, IP kamera sistemleri ve güvenlik çözümleri. Gebze, Dilovası, Çayırova OSB fiber altyapı.');
    }

    // Canonical link
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `${import.meta.env.VITE_SITE_URL}/bolgeler/kocaeli`;
    document.head.appendChild(canonical);

    // Open Graph tags
    const ogTitle = document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    ogTitle.content = 'Kocaeli Fiber Optik ve Güvenlik Sistemleri | Fiber Ek Hizmeti';
    document.head.appendChild(ogTitle);

    const ogDescription = document.createElement('meta');
    ogDescription.setAttribute('property', 'og:description');
    ogDescription.content = 'Kocaeli fiber kablo tamiri, fiber ek hizmeti, fusion splicing, OTDR test, IP kamera sistemleri ve güvenlik çözümleri. Gebze, Dilovası, Çayırova OSB fiber altyapı.';
    document.head.appendChild(ogDescription);

    const ogUrl = document.createElement('meta');
    ogUrl.setAttribute('property', 'og:url');
    ogUrl.content = `${import.meta.env.VITE_SITE_URL}/bolgeler/kocaeli`;
    document.head.appendChild(ogUrl);

    const ogType = document.createElement('meta');
    ogType.setAttribute('property', 'og:type');
    ogType.content = 'website';
    document.head.appendChild(ogType);

    const ogLocale = document.createElement('meta');
    ogLocale.setAttribute('property', 'og:locale');
    ogLocale.content = 'tr_TR';
    document.head.appendChild(ogLocale);

    // JSON-LD Schema
    const schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Fiber Ek - Kocaeli",
      "description": "Kocaeli'de fiber optik altyapı kurulumu, IP kamera sistemleri, yangın alarm ve güvenlik çözümleri",
      "areaServed": "Kocaeli",
      "telephone": "+905537165561",
      "url": `${import.meta.env.VITE_SITE_URL}/bolgeler/kocaeli`,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Kocaeli",
        "addressRegion": "Kocaeli",
        "addressCountry": "TR"
      }
    });
    document.head.appendChild(schema);

    return () => {
      document.head.removeChild(canonical);
      document.head.removeChild(ogTitle);
      document.head.removeChild(ogDescription);
      document.head.removeChild(ogUrl);
      document.head.removeChild(ogType);
      document.head.removeChild(ogLocale);
      document.head.removeChild(schema);
    };
  }, []);

  const faqs = [
    {
      question: 'Kocaeli\'nde fiber kablo tamiri ne kadar sürer?',
      answer: 'Acil fiber arıza durumlarında 30 dakika içinde Kocaeli\'nin her noktasına ulaşıyoruz. Basit fiber kablo tamiri 1-2 saat, karmaşık fusion splicing işlemleri 3-4 saat içinde tamamlanır.'
    },
    {
      question: 'Kocaeli OSB\'de hangi fiber hizmetleri veriyorsunuz?',
      answer: 'Kocaeli Organize Sanayi Bölgesi\'nde fabrika fiber altyapı kurulumu, fiber optik sonlandırma, fusion splicing hizmeti, OTDR test ve acil fiber arıza müdahalesi veriyoruz. OM3 OM4 fiber ek işlemlerinde uzmanız.'
    },
    {
      question: 'Kocaeli\'nde güvenlik sistemleri kurulumu yapıyor musunuz?',
      answer: 'Evet, Kocaeli genelinde IP kamera sistemleri, hırsız alarm sistemleri, yangın alarm sistemleri, geçiş kontrol sistemleri, turnike ve bariyer sistemleri kurulumu yapıyoruz. Özellikle sanayi tesisleri için özel projeler geliştiriyoruz.'
    },
    {
      question: 'SC LC konnektör sonlandırma hizmeti veriyor musunuz?',
      answer: 'Evet, SC, LC, ST ve FC tipi konnektör sonlandırma işlemlerini profesyonel fusion splicing cihazlarıyla gerçekleştiriyoruz. Her sonlandırma sonrası OTDR test ile kayıp değerlerini raporluyoruz.'
    }
  ];

  return (
    <>
      <FAQSchema faqs={faqs} />
      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900">
        <Navbar />
        <FloatingButtons />

        {/* Hero Section */}
        <section className="relative pt-32 pb-20 overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/0d9aa0aa7fe9e10ba7ad7d9634f8a08f.jpg')] bg-cover bg-center opacity-20"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-blue-600/10 via-transparent to-slate-900/50"></div>
          
          <div className="container mx-auto px-4 relative z-10">
            <Breadcrumb 
              items={[
                { label: 'Ana Sayfa', path: '/' },
                { label: 'Bölgeler', path: '/' },
                { label: 'Kocaeli', path: '/locations/kocaeli' }
              ]} 
            />

            <div className="max-w-4xl mx-auto text-center mt-12">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
                Kocaeli Fiber Optik ve Güvenlik Sistemleri
              </h1>
              <p className="text-xl text-gray-300 mb-8">
                Kocaeli OSB, Gebze, Dilovası ve Çayırova'da Profesyonel Fiber Kablo Tamiri, Fusion Splicing ve Güvenlik Çözümleri
              </p>
              <div className="flex flex-wrap gap-4 justify-center">
                <a 
                  href="tel:+905537165561"
                  className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  Hemen Ara
                </a>
                <a 
                  href="https://wa.me/905537165561"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-20 bg-slate-800/50">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              
              {/* Fiber Optik Hizmetleri */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-flashlight-line text-blue-500"></i>
                  Kocaeli Fiber Optik Hizmetleri
                </h2>
                
                <p className="text-gray-300 mb-6 leading-relaxed">
                  Kocaeli'nde <strong>fiber kablo tamiri</strong>, <strong>fiber optik sonlandırma</strong> ve <strong>Kocaeli fiber ek</strong> hizmetleri sunuyoruz. Gebze, Dilovası, Çayırova ve Kocaeli OSB'deki fabrikalarda 10+ yıllık tecrübemizle <strong>fusion splicing hizmeti</strong> ve <strong>OTDR test hizmeti</strong> veriyoruz. 7/24 <strong>acil fiber arıza</strong> müdahale ekibimiz hazır.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Kocaeli Fiber Ek ve Fusion Splicing</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  <strong>Kocaeli fiber ek</strong> işlemlerinde son teknoloji fusion splicing cihazları kullanıyoruz. Özellikle Gebze ve Dilovası'ndaki fabrika fiber altyapı projelerinde yüksek performanslı <strong>OM3 OM4 fiber ek</strong> işlemleri gerçekleştiriyoruz. <strong>SC LC konnektör sonlandırma</strong> ve <strong>metro ethernet fiber ek</strong> projelerinde minimum kayıp değerleri elde ediyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Fabrika Fiber Altyapı ve OTDR Test</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  Kocaeli OSB'deki fabrikalarda <strong>fabrika fiber altyapı</strong> kurulumu ve <strong>bina fiber kablo tamiri</strong> hizmetleri sunuyoruz. <strong>OTDR test hizmeti</strong> ile fiber hatlarınızdaki tüm bağlantı noktalarını analiz ediyor, kayıp değerlerini detaylı raporlarla sunuyoruz. Fiber optik altyapınızın sağlığını düzenli olarak kontrol ediyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Acil Fiber Arıza Müdahalesi</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  İnşaat kazaları, kazı çalışmaları veya altyapı arızaları nedeniyle kesilen fiber kablolarınıza <strong>acil fiber arıza</strong> ekibimiz 30 dakika içinde müdahale ediyor. Kocaeli, Gebze, Dilovası ve Çayırova'da 7/24 hizmet veren ekibimiz, iş sürekliliğinizi garanti altına alıyor.
                </p>

                <div className="grid md:grid-cols-2 gap-6 mt-8">
                  <Link to="/fiber-services/fiber-cable-repair" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-tools-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Fiber Kablo Tamiri</h4>
                    <p className="text-gray-400 text-sm">7/24 acil arıza müdahalei</p>
                  </Link>
                  <Link to="/fiber-services/otdr-test" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-line-chart-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">OTDR Test</h4>
                    <p className="text-gray-400 text-sm">Fiber hat analizi ve kayıp ölçümü</p>
                  </Link>
                </div>
              </div>

              {/* Güvenlik Sistemleri */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-shield-check-line text-blue-500"></i>
                  Kocaeli Güvenlik Sistemleri
                </h2>
                
                <p className="text-gray-300 mb-6 leading-relaxed">
                  Kocaeli'nde <strong>IP kamera sistemleri</strong>, <strong>hırsız alarm sistemleri</strong>, <strong>yangın alarm sistemleri</strong>, <strong>geçiş kontrol sistemleri</strong>, <strong>turnike sistemleri</strong> ve <strong>bariyer sistemleri</strong> kurulumu yapıyoruz. Özellikle Kocaeli OSB, Gebze OSB ve Dilovası sanayi bölgelerindeki fabrikalar için entegre güvenlik çözümleri sunuyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Sanayi Bölgesi IP Kamera Sistemleri</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  Kocaeli'ndeki fabrikalarda yüksek çözünürlüklü <strong>IP kamera sistemleri</strong> kuruyoruz. Geniş açılı kameralar, gece görüş teknolojisi, hareket algılama ve uzaktan izleme özellikleriyle üretim alanlarınızı 7/24 güvence altına alıyoruz. Bulut tabanlı kayıt sistemleri ile istediğiniz zaman görüntülere erişebilirsiniz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Geçiş Kontrol ve Turnike Sistemleri</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  <strong>Geçiş kontrol sistemleri</strong> ile fabrika girişlerinde personel ve ziyaretçi kontrolü sağlıyoruz. <strong>Turnike sistemleri</strong> ve <strong>bariyer sistemleri</strong> entegrasyonu ile araç ve yaya geçişlerini yönetiyoruz. Kartlı geçiş, parmak izi okuyucu ve plaka tanıma sistemleri kuruyoruz.
                </p>

                <div className="grid md:grid-cols-2 gap-6 mt-8">
                  <Link to="/security-systems/ip-camera-systems" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-camera-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">IP Kamera Sistemleri</h4>
                    <p className="text-gray-400 text-sm">Sanayi tipi güvenlik kameraları</p>
                  </Link>
                  <Link to="/security-systems/access-control-systems" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-door-lock-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Geçiş Kontrol Sistemleri</h4>
                    <p className="text-gray-400 text-sm">Turnike ve bariyer çözümleri</p>
                  </Link>
                </div>
              </div>

              {/* FAQ */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-8">Sıkça Sorulan Sorular</h2>
                <div className="space-y-6">
                  {faqs.map((faq, index) => (
                    <div key={index} className="border-b border-slate-700/50 pb-6 last:border-0">
                      <h3 className="text-xl font-bold text-white mb-3">{faq.question}</h3>
                      <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="py-20 bg-slate-900/30">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-3xl font-bold text-white mb-8 text-center">Konum</h2>
              <div className="rounded-2xl overflow-hidden shadow-2xl border border-slate-700/50">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d194348.47916850024!2d29.688925!3d40.8533!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cb4f8f8f8f8f8f%3A0x8f8f8f8f8f8f8f8f!2sKocaeli!5e0!3m2!1str!2str!4v1234567892"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Kocaeli Harita"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}